import api from "services/backendService";

export const SET_APP_CONFIGURATIONS = "SET_APP_CONFIGURATIONS";

const initialState = {};

const appConfigurations = (state = initialState, action) => {
    switch (action.type) {
        case SET_APP_CONFIGURATIONS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default appConfigurations;

export const initAppConfigurationsAsync = (dispatch, customerGuid, isSuperAdmin) => {
    return new Promise((resolve) => {
        api.getAppConfigurationsAsync(null, customerGuid).then((response) => {
            const configurations = {};
            response.forEach((config) => {
                configurations[config.name] = {
                    isEnabled: config.isEnabled || (isSuperAdmin && config.name !== 'PrivilegedUsers')
                };
            });

            dispatch({
                type: SET_APP_CONFIGURATIONS,
                payload: configurations,
            });
            resolve(response);
        });
    });
};